import { createI18n } from 'vue-i18n';

import {
  app,
  buttons,
  components,
  constants,
  inputs,
  pages,
  placeholders,
} from '@/settings/i18n/locales/pt-BR.json';
import addressInputs from '@/settings/i18n/locales/pt-BR/address/inputs.json';
import bankAccountInputs from '@/settings/i18n/locales/pt-BR/bankAccount/inputs.json';
import bankPartnerInputs from '@/settings/i18n/locales/pt-BR/bankPartner/inputs.json';
import commissionInputs from '@/settings/i18n/locales/pt-BR/commission/inputs.json';
import commissionPages from '@/settings/i18n/locales/pt-BR/commission/pages.json';
import companyInputs from '@/settings/i18n/locales/pt-BR/company/inputs.json';
import companyPages from '@/settings/i18n/locales/pt-BR/company/pages.json';
import contactInputs from '@/settings/i18n/locales/pt-BR/contact/inputs.json';
import dealInputs from '@/settings/i18n/locales/pt-BR/deal/inputs.json';
import dealPages from '@/settings/i18n/locales/pt-BR/deal/pages.json';
import enums from '@/settings/i18n/locales/pt-BR/enums.json';
import identityCardInputs from '@/settings/i18n/locales/pt-BR/identityCard/inputs.json';
import incomeInputs from '@/settings/i18n/locales/pt-BR/income/inputs.json';
import personInputs from '@/settings/i18n/locales/pt-BR/person/inputs.json';
import personPages from '@/settings/i18n/locales/pt-BR/person/pages.json';
import productInputs from '@/settings/i18n/locales/pt-BR/product/inputs.json';
import simulationInputs from '@/settings/i18n/locales/pt-BR/simulation/inputs.json';
import simulationPages from '@/settings/i18n/locales/pt-BR/simulation/pages.json';
import subscriptionInputs from '@/settings/i18n/locales/pt-BR/subscription/inputs.json';
import subsidiaryInputs from '@/settings/i18n/locales/pt-BR/subsidiary/inputs.json';
import subsidiaryPages from '@/settings/i18n/locales/pt-BR/subsidiary/pages.json';
import userInputs from '@/settings/i18n/locales/pt-BR/user/inputs.json';
import userPages from '@/settings/i18n/locales/pt-BR/user/pages.json';

const ptBRMessages = {
  app,
  buttons,
  constants,
  components,
  placeholders,
  enums,
  pages: {
    ...pages,
    deal: dealPages,
    company: companyPages,
    simulation: simulationPages,
    commission: commissionPages,
    user: userPages,
    subsidiary: subsidiaryPages,
    person: personPages,
  },
  inputs: {
    ...inputs,
    user: userInputs,
    deal: dealInputs,
    income: incomeInputs,
    company: companyInputs,
    product: productInputs,
    address: addressInputs,
    contact: contactInputs,
    products: productInputs,
    subsidiary: subsidiaryInputs,
    simulation: simulationInputs,
    bankAccount: bankAccountInputs,
    bankPartner: bankPartnerInputs,
    subscription: subscriptionInputs,
    identityCard: identityCardInputs,
    commission: commissionInputs,
    person: personInputs,
  },
};

const messages = {
  'pt-BR': ptBRMessages,
  pt: ptBRMessages,
};

const i18n = createI18n({
  messages,
  locale: 'pt-BR',
  globalInjection: true,
  fallbackLocale: 'pt-BR',
  numberFormats: {
    'pt-BR': {
      currency: {
        style: 'currency',
        currency: 'BRL',
      },
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      },
    },
  },
  dateTimeFormats: {
    'pt-BR': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long',
        hour: 'numeric',
        minute: 'numeric',
      },
      dateTime: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      },
    },
  },
});

const { t } = i18n.global;
export { t };
export default i18n;
